import { FactoryResponse as ResponseApi } from '@/types/_'

export default class FactoryResponse {
  public build<T = any>(request): ResponseApi<T> {
    const responseApi: ResponseApi<T> = { }
    responseApi.success = request.status === 200 || request.status === 204
    if (request && request.data) {
      responseApi.data = request.data.data || request.data
    }

    if (request.response && request.response.data && request.response.data.message) {
      responseApi.message = request.response.data.message
    }
    if (request.response && request.response.data && request.response.data.errors) {
      responseApi.errors = request.response.data.errors
    }
    return responseApi
  }
}
